import {charcoal} from '../sass/base/_exports.sass';

export const ZoomOutIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <path fill={color} d="M6.842 11.9735h13.684v3.421H6.842Z" />
      <path
        fill={color}
        d="M13.684 27.368a13.603 13.603 0 0 0 8.3763-2.8873L29.5796 32l2.4187-2.4186-7.5194-7.5194a13.6 13.6 0 0 0 2.889-8.378C27.368 6.139 21.229 0 13.684 0S0 6.139 0 13.684s6.139 13.684 13.684 13.684m0-23.947c5.66 0 10.263 4.603 10.263 10.263s-4.603 10.263-10.263 10.263S3.421 19.344 3.421 13.684 8.024 3.421 13.684 3.421"
      />
    </svg>
  );
};
